import styled, { css } from 'styled-components'
import { themeGet } from 'styled-system'
import { IconCaretSelect, SearchSelect } from 'secondstep-components'

export const adminDropdownShellStyles = css`
  padding-right: 1.5rem;
  position: relative;
`

export const adminDropdownTriggerStyles = css`
  align-items: center;
  background-color: transparent;
  border: transparent;
  border-bottom: 1px solid transparent;
  border-radius: 0;
  color: ${themeGet('colors.white')};
  cursor: pointer;
  display: flex;
  font-family: ${themeGet('fontFamilySemibold')};
  font-size: 1rem;
  height: unset;
  justify-content: flex-start;
  line-height: 1.75rem;
  margin-bottom: 0.1875rem;
  padding: 0;
  z-index: 2;

  img {
    position: relative;
    padding-right: 0.375rem;
  }

  svg {
    color: ${themeGet('colors.white')} !important;
  }

  span {
    padding: 0 0.5rem 0 0.2rem;
    line-height: 1.75rem;
  }

  &:hover {
    background: none;
    border-bottom: 1px solid ${themeGet('colors.white')};
    border-radius: 0;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-color: transparent;
    box-shadow: 0 0 2px 2px ${themeGet('colors.blueGray')};
    outline: none;
  }
`

export const adminDropdownCaretStyles = css`
  color: ${themeGet('colors.white')} !important;
  height: 0.75rem;
  margin-left: auto;
  width: 0.875rem;
`

export const adminDropdownPanelChromeStyles = css`
  background: ${themeGet('colors.white')};
  border: none;
  border-radius: 0.3125rem;
  box-shadow: 0 0 1.375rem rgba(0, 0, 0, 0.2);
  width: max-content;
  min-width: 100%;
  z-index: 4;
`

export const adminDropdownOptionStyles = css`
  background: none;
  border: none;
  color: ${themeGet('colors.blueGray')};
  cursor: pointer;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: 1.3125rem;
  padding: 0.2rem 0.5rem;
  text-align: left;

  &:hover,
  &:focus {
    background: none;
    color: ${themeGet('colors.secondStepBlue')};
  }
`

export const DropdownWrapper = styled.div`
  ${adminDropdownShellStyles}
`

export const DropdownButton = styled.button`
  ${adminDropdownTriggerStyles}
`

export const StyledIconCaretSelect = styled(IconCaretSelect)`
  ${adminDropdownCaretStyles}
  margin-bottom: ${({ $isOpen }) => ($isOpen ? '0.125rem' : '0')};
  margin-top: ${({ $isOpen }) => ($isOpen ? '-0.125rem' : '0')};
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
`

export const DropdownPanel = styled.div`
  ${adminDropdownPanelChromeStyles}
  left: 0.5rem;
  margin-top: 0.25rem;
  padding: 1rem 1.75rem;
  position: absolute;
  top: 100%;
`

export const StyledSearchSelect = styled(SearchSelect)`
  ${adminDropdownShellStyles}

  button {
    ${adminDropdownTriggerStyles}

    svg:last-of-type {
      ${adminDropdownCaretStyles}
    }
  }

  [class*='LabelWrapper'] {
    display: none;
  }

  [class*='DropdownOptions'] {
    ${adminDropdownPanelChromeStyles}
    margin-top: 0.25rem;
    padding: 0.25rem 0;

    button {
      ${adminDropdownOptionStyles}

      svg {
        padding-left: 0.5rem;
      }

      &:hover,
      &:focus,
      &.arrow-selected {
        span,
        svg {
          color: ${themeGet('colors.secondStepBlue')};
        }
      }
    }

    span {
      color: ${themeGet('colors.blueGray')};
      font-family: ${themeGet('font.molde.medium')};
      font-size: 1rem;
      line-height: 1.3125rem;
    }
  }

  [class*='DropdownSpaceFiller'] {
    display: none;
  }
`
